import React, { memo, useEffect, useMemo } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import { useVersionStore } from 'store/version.store';

import { useQueryGetResourceListForChart } from 'api/queries/getResourceListForChart.query';

import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import classes from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage.module.scss';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    versionId?: number | undefined;
    value?: string;
}

export const ResourceFilter = memo(({ methods, name, filtersStatusRef, handleFilters, versionId, value }: Props) => {
    const { data, isFetching, isSuccess } = useQueryGetResourceListForChart({
        latestVersion: versionId,
    });

    const options = useMemo<ISelectOption<number>[]>(() => (data ? data : []), [data]);

    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady || !isSuccess) {
            return;
        }
        if (value) {
            methods?.setValue(name, Number(value));
        }

        signalSingleFilterIsReady({ filterId: name, isReady: isSuccess });
    }, [value, data, filtersStatusRef, name, isSuccess, methods]);

    const handleChange = (value: ISelectOption<number> | null) => {
        methods?.setValue(name, value ? value.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (filterValue) => {
        if (!filterValue) {
            return null;
        }
        return data?.find((item) => item.value === Number(filterValue)) || null;
    };

    return (
        <div className={classes.selectWrapper}>
            <div className={classes.activityCodesSelectWrapper}>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<number>>
                            {...field}
                            options={options}
                            id={'global-filter-component-resource'}
                            isClearable={true}
                            isLoading={isFetching}
                            onChange={handleChange}
                            value={handleValue(field.value)}
                            placeholder={'Select resource...'}
                            label={FilterLabels.resource}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    );
});
